import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one query client.
 *
 * It lives here rather than in `main.tsx` because the products collection
 * needs it too: `queryCollectionOptions` takes a client, and giving it a
 * second one would put the catalog in a cache nothing else can invalidate.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});
